export default [
    "18 18",
    '<path d="M1.5 1.5H8.55882V8.55882H1.5V1.5Z" fill="var(--ci-primary-color, currentColor)"  />\n' +
    '<path d="M9.44118 1.5H16.5V8.55882H9.44118V1.5Z" fill="var(--ci-primary-color, currentColor)"  />\n' +
    '<path d="M1.5 9.44118H8.55882V16.5H1.5V9.44118Z" fill="var(--ci-primary-color, currentColor)"  />\n' +
    '<path d="M9.44118 9.44118H16.5V16.5H9.44118V9.44118Z" fill="var(--ci-primary-color, currentColor)"  />'
]

